import { useEffect, useState } from 'react';

import {
  peekAnimeCover,
  resolveAnimeCover,
  type AnimeCover,
} from '@/lib/anime-cover-cache';

/**
 * React hook that resolves the anime cover for a kara via Yozora.
 * Starts with whatever's already cached so first paint can show a
 * cover instantly when the same anime was rendered earlier on the
 * page (e.g. multiple OP/ED rows that share a series).
 */
export function useAnimeCover(
  animeId: number | null | undefined,
  animeName: string | null | undefined
): AnimeCover | null {
  const [cover, setCover] = useState<AnimeCover | null>(() =>
    peekAnimeCover(animeId, animeName)
  );

  useEffect(() => {
    let cancelled = false;
    const next = peekAnimeCover(animeId, animeName);
    if (next) {
      setCover(next);
      return () => {
        cancelled = true;
      };
    }
    setCover(null);
    resolveAnimeCover(animeId, animeName).then((resolved) => {
      if (cancelled) return;
      setCover(resolved);
    });
    return () => {
      cancelled = true;
    };
  }, [animeId, animeName]);

  return cover;
}
